import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import BurgerMenu from './BurgerMenu';
import ChevronDown from './ChevronDown';
import ChevronLeft from './ChevronLeft';
import ChevronRight from './ChevronRight';
import ChevronSlim from './ChevronSlim';
import ChevronUp from './ChevronUp';
import ExternalLink from './ExternalLink';
import MenuClose from './MenuClose';
import Search from './Search';
import SearchOulined from './SearchOulined';
import Checkbox from './Checkbox';
import CheckboxChecked from './CheckboxChecked';
import CloseCircle from './CloseCircle';
import Close from './Close';
import Tick from "./Tick";
import Plane from "./Plane";
import TimerClock from './TimerClock';
import Video from "./Video";
import Image from "./Image";
import Previous from "./Previous";
import Next from "./Next";
import Container from './Container';
import Calendar from "./Calendar";
import Popup from './Popup';

const IconComponent = (props) => {
    const {icon, ...svgProps} = props;
    const Icons ={
    'arrow-left': <ArrowLeft {...svgProps}/>,
    'arrow-right': <ArrowRight {...svgProps}/>,
    'burger-menu': <BurgerMenu {...svgProps}/>,
    'chevron-down': <ChevronDown {...svgProps}/>,
    'chevron-left': <ChevronLeft {...svgProps}/>,
    'chevron-right': <ChevronRight {...svgProps}/>,
    'chevron-up': <ChevronUp {...svgProps}/>,
    'chevron-slim': <ChevronSlim {...svgProps}/>,
    'checkbox': <Checkbox {...svgProps}/>,
    'checkbox-checked': <CheckboxChecked {...svgProps}/>,
    'external-link': <ExternalLink {...svgProps}/>,
    'menu-close': <MenuClose {...svgProps}/>,
    'search': <Search {...svgProps}/>,
    'search-outlined': <SearchOulined {...svgProps}/>,
    "close-circle": <CloseCircle {...svgProps}/>,
    "close": <Close {...svgProps}/>,
    "tick": <Tick {...svgProps}/>,
    "plane": <Plane {...svgProps}/>,
    "time": <TimerClock {...svgProps}/>,
    "image": <Image {...svgProps}/>,
    "video": <Video {...svgProps}/>,
    "previous": <Previous {...svgProps}/>,
    "next": <Next {...svgProps}/>,
    "container": <Container {...svgProps}/>,
    "calendar": <Calendar {...svgProps}/>,
    "popup" : <Popup {...svgProps}/>
    }

    return Icons[icon]
}

export default IconComponent;